import { render, staticRenderFns } from "./DetalheDadosLicitacaoDadosGerais.vue?vue&type=template&id=e49ff8c6"
import script from "./DetalheDadosLicitacaoDadosGerais.vue?vue&type=script&lang=js"
export * from "./DetalheDadosLicitacaoDadosGerais.vue?vue&type=script&lang=js"
import style0 from "./DetalheDadosLicitacaoDadosGerais.vue?vue&type=style&index=0&id=e49ff8c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports